/* Rotating announcement bar.

   Mayave cycles a few one-line promises with arrows either side. The theme
   only supports a single static message, so the lines are carried in a
   data attribute and swapped here: fade out, change text, fade in.

   Pauses on hover, stops entirely for prefers-reduced-motion, and the arrows
   are real buttons so it is operable by keyboard. */
(function () {
  var INTERVAL = 4600;

  function init(el) {
    if (el.dataset.ivReady) return;
    var lines = (el.getAttribute('data-iv-rotate') || '').split('|')
      .map(function (s) { return s.trim(); }).filter(Boolean);
    if (lines.length < 2) return;
    el.dataset.ivReady = '1';

    var bar = el.closest('.m-topbar') || el.parentElement;
    bar.classList.add('iv-announce');

    var i = 0, timer = null;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function paint(next) {
      i = (next + lines.length) % lines.length;
      if (reduce) { el.textContent = lines[i]; return; }
      el.style.opacity = '0';
      setTimeout(function () {
        el.textContent = lines[i];
        el.style.opacity = '1';
      }, 220);
    }

    function start() { if (!reduce && !timer) timer = setInterval(function () { paint(i + 1); }, INTERVAL); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    function arrow(dir, label) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'iv-announce__arrow iv-announce__arrow--' + (dir < 0 ? 'prev' : 'next');
      b.setAttribute('aria-label', label);
      b.innerHTML = dir < 0
        ? '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>'
        : '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>';
      b.addEventListener('click', function () { stop(); paint(i + dir); start(); });
      return b;
    }

    el.style.transition = 'opacity .22s ease';
    bar.insertBefore(arrow(-1, 'Previous announcement'), bar.firstChild);
    bar.appendChild(arrow(1, 'Next announcement'));

    bar.addEventListener('mouseenter', stop);
    bar.addEventListener('mouseleave', start);
    start();
  }

  function boot() { document.querySelectorAll('[data-iv-rotate]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
